import { PdfUserSettingsCategories } from 'modules/Shared/PdfPrint/usePdfUserSettings';

export const healthCheckPdfSettingsCategories: PdfUserSettingsCategories = {
	dealer: 'HealthCheckPdfSettingsDealer',
	customer: 'HealthCheckPdfSettingsCustomer',
};
